var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"custom-select select-multiple",attrs:{"autocomplete":"off","multiple":true}},_vm._l((_vm.options),function(option){return _c('option',{key:option,domProps:{"value":option}},[_vm._v("\n        "+_vm._s(option)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }